import * as util from 'util';
import {Buffer} from 'safe-buffer';
import _ from 'lodash';
import {GeneralService} from '../../../../services/generalService';
import {AuthService} from '../../../../services/authService';
import {DICTIONARY} from '../../../../dictionary';
import {RouteService} from '../../../../services/routeService';
import {NotificationService} from '../../../../services/notificationService';
import {ENV_CONSTS} from '../../../../constants';
import {Component, NgZone, OnInit} from "@angular/core";
import {ClipboardService} from 'ngx-clipboard';
import {Router} from "@angular/router";


@Component({
	selector: 'integrations-component',
	templateUrl: './integrations.component.html',
})
export class IntegrationsComponent implements OnInit {
    dic = DICTIONARY;
	pageOrigin; // inbound, outbound, admin
	// CC: taken from collaboration-overview.component.ts -> tabs/activeTab. The webhooks tab is added in the constructor (outbound/admin only)
	tabs: any = {
		general: 'Services',
		api: 'API',
		mcp: 'MCP',
	};
	activeTab = this.tabs.general;
	activeTabIndex = 0;
	tabWidth = 150;
    openIDRedirectUrl = [
        {url: window.location.origin, description: 'Used to log into the Trustifi web app'},
		{url: window.location.origin+'/redirect.html', description: 'Used to test the Trustifi web app'},
        {url: location.origin.includes('stage') || location.origin.includes('localhost') ? 'https://stageoaddin.trustifi.com/redirect.html' : 'https://oaddin.trustifi.com/redirect.html', description: "Used to log into the Trustifi Outlook add-in"},
        {url: location.origin.includes('stage') || location.origin.includes('localhost') ? 'https://stageea.trustifi.com/redirect.html' : 'https://ea.trustifi.com/redirect.html', description: "Used to authenticate recipients in encrypted emails"},
        {url: 'https://nkjiffgankhjcemjlikehngfajkdgfgd.chromiumapp.org/oauth2/redirect.html', description: "Used to log into the Trustifi Chrome extension"},
    ];
    samlRedirectUrl = ENV_CONSTS.outsideUrl + "/saml/callback";
    samlLogoutUrl = ENV_CONSTS.outsideUrl + "/saml/logout";
    samlAudience = DICTIONARY.CONSTANTS.samlAudience;

    planInfo: any;
    userInfo: any;
    selectedServerEndpoint: { name: string; AzureAD: string; MSGraphAPI: string; ExoAdminAPI: string};
    selectedIntegrationObj: any;
    integrationActionInProcess: boolean;
    gsuiteConfigPopup: any;
	gsuiteAdvancedPopup: any;
    checkpointConnectPopup: any;
    openIDConfigPopup: any;
    samlConfigPopup: any;
    S3ConnectPopup: any;
	syslogConnectPopup: any;
	splunkConnectPopup: any;
	qradarConnectPopup: any;
	graylogConnectPopup: any;
	sentinelOneConnectPopup: any;
	sumoLogicConnectPopup: any;
	rapid7ConnectPopup: any;
	crowdStrikeConnectPopup: any;
	huntersConnectPopup: any;
	haloPSAConnectPopup: any;
	connectWiseConnectPopup: any;
	autotaskConnectPopup: any;
	superOpsConnectPopup: any;
	xsiamConnectPopup: any;
	azureEventHubConnectPopup: any;
	microsoftSentinelConnectPopup: any;
	stellarCyberConnectPopup: any;
	hasWKTextSecurity = this.gs.hasWKTextSecurity();
	syslogProtocols = ['udp', 'tcp', 'tls', 'unix', 'unix-connect'];
	showPassword: boolean;
	showAliases: boolean;
	showGroups: boolean;
	integImportGroupsSummary: boolean;
	changeEndPointPopup;
	isLoaded;
	// CC: partner-only flag for "Sync Managed Plan Data to SIEM/PSA" toggle
	isPartnerAdmin;

	exchangePowershellCommands = {
		login:'login',
		verify:'verify',
		disconnect: 'disconnect',
		enableSyncQuarantine: 'enableSyncQuarantine',
		enableAutomaticRelease: 'enableAutomaticRelease',
		autoReleaseForReScan: 'autoReleaseForReScan',
		quarantine:'quarantine',
		rules:'rules',
		updateRules:'updateRules',
		protection:'protection',
		junkRule:'junkRule',
		configuration:'configuration'
	};

	exchangePowershellPopup = {};

	integrationsEmailInfraData:any = {
		[this.dic.CONSTANTS.integrationType.exchange]: {
			desc: 'Synchronize groups, distribution lists, and aliases from Exchange. Enhance security by providing access to user contacts and mailboxes.'
		},
		[this.dic.CONSTANTS.integrationType.gsuite]: {
			desc: 'Synchronize groups, distribution lists, and aliases from Google. Enhance security by providing access to user contacts and mailboxes.'
		},
		[this.dic.CONSTANTS.integrationType.powershell]: {
			desc: 'Execute advanced actions through automated PowerShell scripts - modify security policies, create connectors and rules, and more.'
		},
		[this.dic.CONSTANTS.integrationType.ldap]: 		{
			desc: 'Synchronize information of groups, distribution lists, and aliases. Ensures seamless management and up-to-date data across systems through LDAP.'
		}
	};

	integrationsSiemData:any = {
		[this.dic.CONSTANTS.integrationType.syslog]: {},
		[this.dic.CONSTANTS.integrationType.splunk]: {},
		[this.dic.CONSTANTS.integrationType.qradar]: {},
		[this.dic.CONSTANTS.integrationType.graylog]: {},
		[this.dic.CONSTANTS.integrationType.sentinelOne]: {},
		[this.dic.CONSTANTS.integrationType.sumoLogic]: {},
		[this.dic.CONSTANTS.integrationType.rapid7]: {},
		[this.dic.CONSTANTS.integrationType.crowdStrike]: {},
		[this.dic.CONSTANTS.integrationType.huntress]: {},
		[this.dic.CONSTANTS.integrationType.eventhub]: {},
		[this.dic.CONSTANTS.integrationType.microsoftSentinel]: {},
		[this.dic.CONSTANTS.integrationType.stellarCyber]: {},
		// [this.dic.CONSTANTS.integrationType.xsiam]: {},
	};

	integrationsAuthData:any = {
		[this.dic.CONSTANTS.integrationType.openid]: 	{},
		[this.dic.CONSTANTS.integrationType.saml]: 		{},
	};

	integrationsPsaData:any = {
		[this.dic.CONSTANTS.integrationType.haloPSA]: 		{},
		[this.dic.CONSTANTS.integrationType.connectWise]: 	{},
		[this.dic.CONSTANTS.integrationType.autotask]: 		{},
		[this.dic.CONSTANTS.integrationType.superOps]: 		{},
	};

	integrationsSecurityData:any = {
		[this.dic.CONSTANTS.integrationType.checkpoint]: {
			desc: 'Enables a two-way exchange of threat information, receiving details on emerging endpoint threats and sending back insights on new email-based threats.'
		},
		[this.dic.CONSTANTS.integrationType.s3]: 		{
			desc: 'Provide access to your own secure S3 buckets to store your encrypted and private data generated in Trustifi.'
		}
	};


	webHooksEvents = JSON.parse(JSON.stringify([
		this.dic.EVENTS.eventDelivery, this.dic.EVENTS.eventRead, this.dic.EVENTS.eventDownloaded,
		this.dic.EVENTS.eventLinkClicked, this.dic.EVENTS.eventHardBounceGeneral
	]));
	webHooksUpdateInProcess = false;
	webHooksUsersPopup: any;

	constructor(public gs:GeneralService,
				private rs:RouteService,
				private ns:NotificationService,
				private authService:AuthService,
				private router:Router,
				private ngZone:NgZone,
				private clipboard : ClipboardService) {
		if (this.router.url.includes(this.dic.CONSTANTS.appStates.adminInbound)) {
			this.pageOrigin = 'inbound';
		}
		else {
			if (this.router.url.includes(this.dic.CONSTANTS.appStates.adminOutbound)) {
				this.pageOrigin = 'outbound';
			}
			else {
				this.pageOrigin = 'admin';
			}
		}

		if (this.pageOrigin === 'outbound' || this.pageOrigin === 'admin') {
			this.tabs.webHooks = 'Webhooks';
		}
    }

	setActiveTab(tabValue) {
		this.activeTab = tabValue;
		this.activeTabIndex = _.values(this.tabs).indexOf(tabValue);
	}

	ngOnInit(): void {
        this.gs.getUserInfo(false, userInfo => {
            this.userInfo = userInfo;
            // CC: taken from plan-settings-domain.component.ts -> ngOnInit
            this.isPartnerAdmin = this.gs.isPartnerAdmin(this.userInfo);

			if (window.history.state?.integrationType) {
				const integrationType = window.history.state.integrationType;
				const integrationObj = [this.integrationsEmailInfraData, this.integrationsSiemData, this.integrationsAuthData,
					this.integrationsSecurityData, this.integrationsPsaData].map(itm => itm[integrationType]).find(itm => itm);
				if (integrationObj) {
					this.selectIntegration(integrationObj);
				}
			}
        });

		this.getIntegrations();
	};

	getIntegrations = () => {
		this.rs.getIntegrations().then((planInfo) => {
			this.planInfo = planInfo;
			this.planInfo.integrations = this.planInfo.integrations || {};
			this.planInfo.integrations.s3 = this.planInfo.integrations.s3 || {};
			this.planInfo.integrations.openid = this.planInfo.integrations.openid || {};
			this.planInfo.integrations.saml = this.planInfo.integrations.saml || {};

			this.selectedServerEndpoint = _.clone(this.dic.CONSTANTS.exchangeServerEndpoints.Global);
			if (this.planInfo.exchange_server?.endpoint_name) {
				this.selectedServerEndpoint.name = this.planInfo.exchange_server.endpoint_name;
				this.selectedServerEndpoint.AzureAD = this.planInfo.exchange_server.azuread_endpoint;
				this.selectedServerEndpoint.MSGraphAPI = this.planInfo.exchange_server.msgraph_endpoint;
				this.selectedServerEndpoint.ExoAdminAPI = this.planInfo.exchange_server.exoadmin_endpoint;
			}

			if (!this.selectedServerEndpoint.AzureAD) {
				this.selectedServerEndpoint.AzureAD = DICTIONARY.CONSTANTS.exchangeServerEndpoints.Global.AzureAD;
			}

			for (const [key, value] of Object.entries(this.integrationsEmailInfraData)) {
				this.integrationsEmailInfraData[key].enabled = this.isIntegrationConnected(key);
				this.integrationsEmailInfraData[key].key = Object.keys(this.dic.CONSTANTS.integrationType)
					.find(k => this.dic.CONSTANTS.integrationType[k] === key);
				this.integrationsEmailInfraData[key].name = key;
				this.integrationsEmailInfraData[key].logo = `images/integrationsLogos/${this.integrationsEmailInfraData[key].key}-logo.png`;
			}

			for (const [key, value] of Object.entries(this.integrationsSiemData)) {
				this.integrationsSiemData[key].enabled = this.isIntegrationConnected(key);
				this.integrationsSiemData[key].key = Object.keys(this.dic.CONSTANTS.integrationType)
					.find(k => this.dic.CONSTANTS.integrationType[k] === key);
				this.integrationsSiemData[key].name = key;
				this.integrationsSiemData[key].logo = `images/integrationsLogos/${this.integrationsSiemData[key].key}-logo.png`;
			}

			for (const [key, value] of Object.entries(this.integrationsAuthData)) {
				this.integrationsAuthData[key].enabled = this.isIntegrationConnected(key);
				this.integrationsAuthData[key].key = Object.keys(this.dic.CONSTANTS.integrationType)
					.find(k => this.dic.CONSTANTS.integrationType[k] === key);
				this.integrationsAuthData[key].name = key;
				this.integrationsAuthData[key].logo = `images/integrationsLogos/${this.integrationsAuthData[key].key}-logo.png`;
			}

			for (const [key, value] of Object.entries(this.integrationsSecurityData)) {
				this.integrationsSecurityData[key].enabled = this.isIntegrationConnected(key);
				this.integrationsSecurityData[key].key = Object.keys(this.dic.CONSTANTS.integrationType)
					.find(k => this.dic.CONSTANTS.integrationType[k] === key);
				this.integrationsSecurityData[key].name = key;
				this.integrationsSecurityData[key].logo = `images/integrationsLogos/${this.integrationsSecurityData[key].key}-logo.png`;
			}

			for (const [key, value] of Object.entries(this.integrationsPsaData)) {
				this.integrationsPsaData[key].enabled = this.isIntegrationConnected(key);
				this.integrationsPsaData[key].key = Object.keys(this.dic.CONSTANTS.integrationType)
					.find(k => this.dic.CONSTANTS.integrationType[k] === key);
				this.integrationsPsaData[key].name = key;
				this.integrationsPsaData[key].logo = `images/integrationsLogos/${this.integrationsPsaData[key].key}-logo.png`;
			}

			if (this.pageOrigin === 'outbound' || this.pageOrigin === 'admin') {
				this.webHooksEvents.forEach((eventObj) => {
					eventObj.explanation = eventObj.desc;
				});

				if (this.planInfo.web_hooks?.events?.events?.length) {
					this.planInfo.web_hooks.events.events.forEach((eventName) => {
						const eventObj = this.webHooksEvents.find(itm => itm.name === eventName);
						if (eventObj) {
							// @ts-ignore
							eventObj.selected = true;
						}
					});
				}
			}

			this.isLoaded = true;

		}, (err) => {

		});
	}

	copyText(text) {
		this.clipboard.copy(text);
	};

	readSamlXml() {
		setTimeout(() => {
			if (!this.samlConfigPopup.samlMetadataFile) return;

			const reader = new FileReader();
			reader.onload = (e) => {
				this.samlConfigPopup.samlMetadata = Buffer.from(<any>e.target.result).toString();
			};
			reader.readAsArrayBuffer(this.samlConfigPopup.samlMetadataFile);
		}, 1000);
	};

	selectIntegration(integrationObj) {
        this.selectedIntegrationObj = integrationObj;
    }

	// an integration is not always registered as a tile (xsiam has no tile yet), so never assume the entry exists
	setIntegrationEnabled = (integrationsData, type, enabled) => {
		if (integrationsData[type]) {
			integrationsData[type].enabled = enabled;
		}
	};

	isIntegrationConnected = (integration) => {
		switch (integration) {
			case this.dic.CONSTANTS.integrationType.exchange:
				return !!(this.planInfo.exchange_server?.tid && this.planInfo.exchange_server?.enabled);

			case this.dic.CONSTANTS.integrationType.powershell:
				return !!(this.planInfo.powershell?.enabled && (this.planInfo.powershell?.refresh_token || this.planInfo.exchange_server?.exoadmin_enabled));

			case this.dic.CONSTANTS.integrationType.gsuite:
				return !!this.planInfo.gsuite_server?.customer_id && this.planInfo.gsuite_server?.enabled;

			case this.dic.CONSTANTS.integrationType.checkpoint:
				return !!this.planInfo.integrations.checkpoint?.enabled;

			case this.dic.CONSTANTS.integrationType.s3:
				return !!this.planInfo.integrations.s3?.enabled;

			case this.dic.CONSTANTS.integrationType.openid:
				return !!this.planInfo.integrations.openid?.enabled;

			case this.dic.CONSTANTS.integrationType.saml:
				return !!this.planInfo.integrations.saml?.enabled;

			case this.dic.CONSTANTS.integrationType.splunk:
				return !!this.planInfo.integrations.splunk?.enabled;

			case this.dic.CONSTANTS.integrationType.qradar:
				return !!this.planInfo.integrations.qradar?.enabled;

			case this.dic.CONSTANTS.integrationType.graylog:
				return !!this.planInfo.integrations.graylog?.enabled;

			case this.dic.CONSTANTS.integrationType.sentinelOne:
				return !!this.planInfo.integrations.sentinel_one?.enabled;

			case this.dic.CONSTANTS.integrationType.sumoLogic:
				return !!this.planInfo.integrations.sumo_logic?.enabled;

			case this.dic.CONSTANTS.integrationType.rapid7:
				return !!this.planInfo.integrations.rapid7?.enabled;

			case this.dic.CONSTANTS.integrationType.crowdStrike:
				return !!this.planInfo.integrations.crowd_strike?.enabled;

			case this.dic.CONSTANTS.integrationType.huntress:
				return !!this.planInfo.integrations.huntress?.enabled;

			case this.dic.CONSTANTS.integrationType.haloPSA:
				return !!this.planInfo.integrations.haloPSA?.enabled;

			case this.dic.CONSTANTS.integrationType.connectWise:
				return !!this.planInfo.integrations.connectWise?.enabled;

			case this.dic.CONSTANTS.integrationType.autotask:
				return !!this.planInfo.integrations.autoTask?.enabled;

			case this.dic.CONSTANTS.integrationType.superOps:
				return !!this.planInfo.integrations.superOps?.enabled;

			case this.dic.CONSTANTS.integrationType.xsiam:
				return !!this.planInfo.integrations.xsiam?.enabled;

			case this.dic.CONSTANTS.integrationType.syslog:
				return !!this.planInfo.integrations.syslog?.enabled;

			case this.dic.CONSTANTS.integrationType.ldap:
				return !!this.planInfo.integrations.ldap?.enabled;

			case this.dic.CONSTANTS.integrationType.eventhub:
				return !!this.planInfo.integrations.eventhub?.enabled;

			case this.dic.CONSTANTS.integrationType.microsoftSentinel:
				return !!this.planInfo.integrations.microsoft_sentinel?.enabled;

			case this.dic.CONSTANTS.integrationType.stellarCyber:
				return !!this.planInfo.integrations.stellar_cyber?.enabled;

			default:
				return false;
		}
	}

	verifyIntegrationConnection = (selectedIntegrationObj) => {
		if (!selectedIntegrationObj?.enabled) {
			return;
		}

		switch (selectedIntegrationObj.name) {
			case this.dic.CONSTANTS.integrationType.openid:
				this.verifyOpenIDIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.saml:
				this.verifySamlIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.syslog:
				this.verifySyslogIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.splunk:
				this.verifySplunkIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.qradar:
				this.verifyQradarIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.graylog:
				this.verifyGraylogIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.sentinelOne:
				this.verifySentinelOneIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.sumoLogic:
				this.verifySumoLogicIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.rapid7:
				this.verifyRapid7Integration();
				break;

			case this.dic.CONSTANTS.integrationType.crowdStrike:
				this.verifyCrowdStrikeIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.huntress:
				this.verifyHuntersIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.haloPSA:
				this.verifyHaloPsaIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.connectWise:
				this.verifyConnectWiseIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.autotask:
				this.verifyAutotaskIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.superOps:
				this.verifySuperOpsIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.xsiam:
				this.verifyXsiamIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.eventhub:
				this.verifyAzureEventHubIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.microsoftSentinel:
				this.verifyMicrosoftSentinelIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.stellarCyber:
				this.verifyStellarCyberIntegration();
				break;

			case this.dic.CONSTANTS.integrationType.powershell:
				this.openExchangePowershellPopup(this.exchangePowershellCommands.verify);
				break;

			case this.dic.CONSTANTS.integrationType.checkpoint:
				this.verifyCheckPointIntegration(this.planInfo?.integrations.checkpoint.clientId, this.planInfo?.integrations.checkpoint.accessKey);
				break;

			case this.dic.CONSTANTS.integrationType.s3:
				this.verifyS3Integration();
				break;

			case this.dic.CONSTANTS.integrationType.gsuite:
				this.verifyGsuiteIntegration();
				break;
		}
	}

	verifySyslogIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureSyslogIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your Syslog to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	verifyRapid7Integration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureRapid7Integration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your Rapid7 to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	verifyHaloPsaIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureHaloPsaIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your Halo PSA to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	verifyConnectWiseIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureConnectWiseIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your ConnectWise to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	// CC: taken from integrations.component.ts -> verifyConnectWiseIntegration
	verifyAutotaskIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureAutotaskIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your Autotask to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	// CC: taken from integrations.component.ts -> verifyAutotaskIntegration
	verifySuperOpsIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureSuperOpsIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your SuperOps to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	verifyHuntersIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureHuntersIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your Huntress to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	verifyCrowdStrikeIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureCrowdStrikeIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your CrowdStrike to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	// CC: taken from integrations.component.ts -> verifyCrowdStrikeIntegration
	verifyStellarCyberIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureStellarCyberIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage('Test log sent successfully, check your Stellar Cyber to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	verifySumoLogicIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureSumoLogicIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your Sumo Logic to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	verifySentinelOneIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureSentinelOneIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your SentinelOne to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	verifyXsiamIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureXsiamIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your XSIAM to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	verifySplunkIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureSplunkIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your Splunk to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	// CC: taken from integrations.component.ts -> verifySplunkIntegration
	verifyQradarIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureQradarIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your QRadar to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	// CC: taken from integrations.component.ts -> verifyQradarIntegration
	verifyGraylogIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureGraylogIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your Graylog to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	verifyAzureEventHubIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureAzureEventHubIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your Azure EventHub to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

	// CC: taken from integrations.component.ts -> verifyAzureEventHubIntegration
	verifyMicrosoftSentinelIntegration() {
		this.integrationActionInProcess = true;
		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.verifyToken,
		};
		this.rs.configureMicrosoftSentinelIntegration(syslogInfo).then(() => {
			this.integrationActionInProcess = false;
			this.ns.showInfoMessage( 'Test log sent successfully, check your Microsoft Sentinel to verify the log was received');
		},(err) => {
			this.integrationActionInProcess = false;
		});
	}

    connectToIntegration(selectedIntegrationObj) {
        switch (selectedIntegrationObj.name) {
            case this.dic.CONSTANTS.integrationType.exchange:
                this.connectToExchange();
                break;

            case this.dic.CONSTANTS.integrationType.gsuite:
                this.connectToGsuite();
                break;

            case this.dic.CONSTANTS.integrationType.checkpoint:
                this.connectToCheckpoint();
                break;

            case this.dic.CONSTANTS.integrationType.s3:
                this.connectToS3();
                break;

            case this.dic.CONSTANTS.integrationType.openid:
                this.connectOpenID();
                break;

            case this.dic.CONSTANTS.integrationType.saml:
                this.connectSaml();
                break;

			case this.dic.CONSTANTS.integrationType.syslog:
				this.connectToSyslog();
				break;

			case this.dic.CONSTANTS.integrationType.splunk:
				this.connectToSplunk();
				break;

			case this.dic.CONSTANTS.integrationType.qradar:
				this.connectToQradar();
				break;

			case this.dic.CONSTANTS.integrationType.graylog:
				this.connectToGraylog();
				break;

			case this.dic.CONSTANTS.integrationType.sentinelOne:
				this.connectToSentinelOne();
				break;

			case this.dic.CONSTANTS.integrationType.sumoLogic:
				this.connectToSumoLogic();
				break;

			case this.dic.CONSTANTS.integrationType.rapid7:
				this.connectToRapid7();
				break;

			case this.dic.CONSTANTS.integrationType.crowdStrike:
				this.connectToCrowdStrike();
				break;

			case this.dic.CONSTANTS.integrationType.huntress:
				this.connectToHunters();
				break;

			case this.dic.CONSTANTS.integrationType.haloPSA:
				this.connectToHaloPsa();
				break;

			case this.dic.CONSTANTS.integrationType.connectWise:
				this.connectToConnectWise();
				break;

			case this.dic.CONSTANTS.integrationType.autotask:
				this.connectToAutotask();
				break;

			case this.dic.CONSTANTS.integrationType.superOps:
				this.connectToSuperOps();
				break;

			case this.dic.CONSTANTS.integrationType.xsiam:
				this.connectToXsiam();
				break;

			case this.dic.CONSTANTS.integrationType.eventhub:
				this.connectToAzureEventHub();
				break;

			case this.dic.CONSTANTS.integrationType.microsoftSentinel:
				this.connectToMicrosoftSentinel();
				break;

			case this.dic.CONSTANTS.integrationType.stellarCyber:
				this.connectToStellarCyber();
				break;

			case this.dic.CONSTANTS.integrationType.powershell:
				this.connectToPowershell();
				break;
        }
    };

    connectToExchange() {
        if (this.integrationsEmailInfraData[this.dic.CONSTANTS.integrationType.exchange].enabled) {
            this.gs.showPopup({
                title: 'Disconnect from mail server',
                subTitle: `Please note - you are about to cancel the connection to your mail server`,
                body: ["Groups will not be automatically updated", "Inbound Shield will be disabled for all mailboxes"],
                type: this.dic.CONSTANTS.popupWarning,
                doneBtnText: 'Disconnect',
                doneCb: () => {
                    this.integrationActionInProcess = true;
                    let notIdx = this.ns.showInfoMessage('Disconnecting from Exchange server...', {timeout: 0});
                    this.rs.disconnectExchange().then(() => {
                        this.ns.overwriteMessage(notIdx, 'Successfully disconnected from Exchange server');
						this.integrationsEmailInfraData[this.dic.CONSTANTS.integrationType.exchange].enabled = false;
                        this.integrationActionInProcess = false;
                        this.getIntegrations();
                    },(err) => {
                        this.integrationActionInProcess = false;
                    });
                }
            });
        }
        else {
            if (this.planInfo.gsuite_server && this.planInfo.gsuite_server.customer_id && this.planInfo.gsuite_server.enabled) {
                this.ns.showErrorMessage(util.format(DICTIONARY.ERRORS.authDisconnectIntegration, 'Google Workspace'));
                return;
            }

            this.integrationActionInProcess = true;
			this.authService.authMicrosoftExchangeAdmin(this.userInfo.email, this.selectedServerEndpoint.AzureAD, this.planInfo.exchangeAdminAppId, 'admin', this.planInfo.exchange_server?.tid, (err, onPremises) => {
                if (err) {
                    if (err !== true) this.ns.showWarnMessage(err);
                }
                else {
                    if (onPremises) {
                        this.ns.showWarnMessage(this.dic.MESSAGES.exchangeServerOnPremises);
                    }

                    this.ns.showInfoMessage('Successfully connected to Microsoft Exchange');
                }

				this.ngZone.run(() => {
					this.integrationActionInProcess = false;
					this.getIntegrations();
				});
            });
        }
    };

	connectToExchangeAdvanced() {
		this.gs.showPopup({
			title: 'Grant Advanced Permissions',
			subTitle: `You are about to grant Trustifi advanced permissions to your Exchange Office365 tenant. Trustifi will be able to:`,
			type: this.dic.CONSTANTS.popupWarning,
			body: ['Reset user mailbox passwords', 'Disable user mailbox accounts', 'Monitor user mailbox rules', 'View user mailbox sign-ins'],
			doneBtnText: 'Grant',
			doneCb: () => {
				this.integrationActionInProcess = true;
				this.authService.authMicrosoftExchangeAdmin(this.userInfo.email, this.selectedServerEndpoint.AzureAD, this.planInfo.exchangeAdminAdvancedAppId, 'advanced', this.planInfo.exchange_server?.tid, (err, onPremises) => {
					if (err) {
						if (err !== true) this.ns.showWarnMessage(err);
					}
					else {
						if (onPremises) {
							this.ns.showWarnMessage(this.dic.MESSAGES.exchangeServerOnPremises);
						}

						this.ns.showInfoMessage('Successfully connected to Microsoft Exchange');
					}

					this.ngZone.run(() => {
						this.integrationActionInProcess = false;
						this.getIntegrations();
					});
				});
			}
		});
	};

    connectToGsuite() {
        if (this.integrationsEmailInfraData[this.dic.CONSTANTS.integrationType.gsuite].enabled) {
            this.gs.showPopup({
                title: 'Disconnect from Google Workspace',
                subTitle: `Please note - you are about to cancel the connection to your Google Workspace`,
                body: ["Groups will not be automatically updated", "Inbound Shield will be disabled for all mailboxes"],
                type: this.dic.CONSTANTS.popupWarning,
                doneBtnText: 'Disconnect',
                doneCb: () => {
                    this.integrationActionInProcess = true;
                    let notIdx = this.ns.showInfoMessage('Disconnecting from Google Workspace server...', {timeout: 0});

                    this.rs.disconnectGSuite().then(() => {
                        this.integrationActionInProcess = false;
						this.integrationsEmailInfraData[this.dic.CONSTANTS.integrationType.gsuite].enabled = false;
                        this.ns.overwriteMessage(notIdx, 'Successfully disconnected from Google Workspace server');
                        this.getIntegrations();
                    },(err) => {
                        this.integrationActionInProcess = false;
                    });
                }
            });
        }
        else {
            if (this.planInfo.exchange_server && this.planInfo.exchange_server.tid
                && this.planInfo.exchange_server.enabled) {
                this.ns.showErrorMessage(util.format(this.dic.ERRORS.authDisconnectIntegration, 'Exchange Server'));
                return;
            }

            this.gsuiteConfigPopup = {
                gsuiteAdminEmail: '',
                gsuiteCustomerId: '',
                inputErrors: {
                    emailInput: false,
                    idInput: false
                },
                show: true
            };
        }
    };

    connectGSuite() {
        this.gsuiteConfigPopup.inputErrors = {emailInput: false, idInput: false}

        if (!this.gsuiteConfigPopup.gsuiteCustomerId || !this.gsuiteConfigPopup.gsuiteAdminEmail) {
            this.ns.showWarnMessage(this.dic.ERRORS.fillAllRequired);
            this.gsuiteConfigPopup.inputErrors.emailInput = !!!this.gsuiteConfigPopup.gsuiteAdminEmail;
            this.gsuiteConfigPopup.inputErrors.idInput = !!!this.gsuiteConfigPopup.gsuiteCustomerId;
            return;
        }
        if (!this.gs.validateEmail(this.gsuiteConfigPopup.gsuiteAdminEmail)) {
            this.ns.showWarnMessage(util.format(this.dic.ERRORS.invalidEmail, this.gsuiteConfigPopup.gsuiteAdminEmail));
            this.gsuiteConfigPopup.inputErrors.emailInput = true;
            return;
        }

        this.integrationActionInProcess = true;

        const connectInfo = {
            adminEmail: this.gsuiteConfigPopup.gsuiteAdminEmail,
            customerId: this.gsuiteConfigPopup.gsuiteCustomerId
        };
        this.rs.connectGSuite(connectInfo).then(response => {
            this.gsuiteConfigPopup = null;
            this.ns.showInfoMessage('Successfully connected to Google Workspace server');
            this.ngOnInit();

			this.ngZone.run(() => {
				this.integrationActionInProcess = false;
			});
        }, (err) => {
            if (err && err.data && err.data.message && !err.data.display_bar) {
                this.ns.showErrorMessage(err.data.message);
            }
            this.integrationActionInProcess = false;
        });
    };

	verifyGsuiteIntegration = () => {
		this.integrationActionInProcess = true;
		this.rs.verifyGSuite().then((existingScopes) => {
			this.ns.showInfoMessage( 'Google Workspaces is configured successfully');
			this.planInfo.gsuite_server.scopes = existingScopes;
			this.integrationActionInProcess = false;
		}, err => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

	verifyGsuiteScope = (scope, showNotification) => {
		this.gsuiteAdvancedPopup.inProcess = true;
		this.rs.verifyGSuite().then((existingScopes) => {
			if (existingScopes.includes(scope)) {
				if (showNotification) {
					this.ns.showInfoMessage('Advanced scope configured successfully');
				}
			}
			this.gsuiteAdvancedPopup = null;
		}, err => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.gsuiteAdvancedPopup.inProcess = false;
		});
	};

    connectToCheckpoint() {
        if (this.integrationsSecurityData[this.dic.CONSTANTS.integrationType.checkpoint].enabled) {
            this.gs.showPopup({
                title: 'Disconnect from Check Point',
                subTitle: `Please note - you are about to cancel the connection to your Check Point client`,
                body: ["Groups will not be automatically updated"],
                type: this.dic.CONSTANTS.popupWarning,
                doneBtnText: 'Disconnect',
                doneCb: () => {
                    this.integrationActionInProcess = true;

                    const actionInfo = {
                        action: this.dic.CONSTANTS.integrationActions.disable
                    }
                    this.integrationActionInProcess = true;
                    this.rs.configureCheckpoint(actionInfo).then((response) => {
                        this.ns.showInfoMessage( 'Successfully disconnected from Check Point server');
                        this.integrationActionInProcess = false;
                        this.planInfo.integrations.checkpoint = {enabled: false};
						this.integrationsSecurityData[this.dic.CONSTANTS.integrationType.checkpoint].enabled = false;
                    }, err => {
                        this.integrationActionInProcess = false;
                    });
                }
            });
        }
        else {
            this.checkpointConnectPopup = {
                checkpointClientID: '',
                checkpointAccessKey: '',
                show: true
            };
        }
    };

    connectCheckpointExecute() {
        if (!this.checkpointConnectPopup.checkpointAccessKey || !this.checkpointConnectPopup.checkpointClientID) {
            return;
        }
        //  client ID '2fc0b7d9b9a04dfda76e1a95a307bd74' | accessKey '23bb31afc8ed442190d2b64bb6b06aaa'

        this.integrationActionInProcess = true;

        const actionInfo = {
            action: this.dic.CONSTANTS.integrationActions.enable,
            clientId: this.checkpointConnectPopup.checkpointClientID,
            accessKey: this.checkpointConnectPopup.checkpointAccessKey
        }
        this.integrationActionInProcess = true;
        this.rs.configureCheckpoint(actionInfo).then((response) => {
            this.checkpointConnectPopup = null;
            this.ns.showInfoMessage('Successfully enabled Check Point integration');
            this.planInfo.integrations.checkpoint = response.checkpoint;
			this.integrationsSecurityData[this.dic.CONSTANTS.integrationType.checkpoint].enabled = true;
            this.integrationActionInProcess = false;
        }, (err) => {
            if (err && err.data && err.data.message && !err.data.display_bar) {
                this.ns.showErrorMessage(err.data.message);
            }
            this.integrationActionInProcess = false;
        });
    };

    connectOpenID() {
        if (this.integrationsAuthData[this.dic.CONSTANTS.integrationType.openid].enabled) {
            this.gs.showPopup({
                title: 'Disconnect OIDC Integration',
                subTitle: 'Please note - your OIDC integration will be disconnected',
                body: [],
                type: this.dic.CONSTANTS.popupWarning,
                doneBtnText: 'Disconnect',
                doneCb: () => {
                    this.integrationActionInProcess = true;

                    this.rs.disconnectOpenID().then(response => {
						localStorage.idpLogin = '';
						localStorage.logoutUrl = '';
                        this.planInfo.integrations.openid = this.planInfo.integrations.openid || {};
                        this.planInfo.integrations.openid.enabled = false;
						this.integrationsAuthData[this.dic.CONSTANTS.integrationType.openid].enabled = false;
                        this.integrationActionInProcess = false;
                        this.ns.showInfoMessage('Successfully disconnected from OIDC');
                    }, (err) => {
                        this.integrationActionInProcess = false;
                    });
                }
            });
        }
        else {
            if (this.planInfo.integrations.saml && this.planInfo.integrations.saml.enabled) {
                this.ns.showErrorMessage(util.format(DICTIONARY.ERRORS.authDisconnectIntegration, 'SAML'));
                return;
            }

            this.openIDConfigPopup = {
                openIDMetadata: '',
                openIDClientId: '',
                openIDDomainsStr: '',
                show: true
            };
        }
    };

    connectSaml() {
        if (this.integrationsAuthData[this.dic.CONSTANTS.integrationType.saml].enabled) {
            this.gs.showPopup({
                title: 'Disconnect SAML Integration',
                subTitle: 'Please note - your SAML integration will be disconnected',
                body: [],
                type: this.dic.CONSTANTS.popupWarning,
                doneBtnText: 'Disconnect',
                doneCb: () => {
                    this.integrationActionInProcess = true;

                    this.rs.disconnectSaml().then(response => {
						localStorage.idpLogin = '';
						localStorage.logoutUrl = '';
                        this.planInfo.integrations.saml = this.planInfo.integrations.saml || {};
                        this.planInfo.integrations.saml.enabled = false;
						this.integrationsAuthData[this.dic.CONSTANTS.integrationType.saml].enabled = false;
                        this.integrationActionInProcess = false;
                        this.ns.showInfoMessage('Successfully disconnected from SAML');
                    }, (err) => {
                        this.integrationActionInProcess = false;
                    });
                }
            });
        }
        else {
            if (this.planInfo.integrations.openid && this.planInfo.integrations.openid.enabled) {
                this.ns.showErrorMessage(util.format(DICTIONARY.ERRORS.authDisconnectIntegration, 'OIDC'));
                return;
            }

            this.samlConfigPopup = {
                samlMetadata: '',
                samlMetadataFile: '',
                samlDomainsStr: '',
                show: true
            };
        }
    };

    connectOpenIDExecute() {
        /*validation*/
        if (!this.openIDConfigPopup.openIDMetadata) { this.ns.showWarnMessage(util.format(this.dic.ERRORS.emptyField, "Discovery Document Endpoint")); return;}
        if (!this.openIDConfigPopup.openIDClientId) { this.ns.showWarnMessage(util.format(this.dic.ERRORS.emptyField, "Client ID")); return;}
        if (!this.openIDConfigPopup.openIDDomainsStr) { this.ns.showWarnMessage(util.format(this.dic.ERRORS.emptyField, "Domains")); return;}

        const openIDData = {
            metadata: this.openIDConfigPopup.openIDMetadata,
            clientId: this.openIDConfigPopup.openIDClientId,
            domains: this.openIDConfigPopup.openIDDomainsStr.split(',').map(itm => itm.trim())
        };

        if (openIDData.domains.some(itm => !itm.match(DICTIONARY.CONSTANTS.DOMAIN_REGEX))) {
            this.ns.showWarnMessage(this.dic.ERRORS.authDomainFieldInvalid);
            return;
        }

        let domains = this.planInfo.domains && this.planInfo.domains.filter(d => d.verified).map(d => d.domain) || [];
        if (this.planInfo.exchange_server.enabled && this.planInfo.exchange_server.verified_domains) {
            domains = domains.concat(this.planInfo.exchange_server.verified_domains);
        }
        if (this.planInfo.gsuite_server.enabled && this.planInfo.gsuite_server.verified_domains) {
            domains = domains.concat(this.planInfo.gsuite_server.verified_domains);
        }
        if (domains.length && !openIDData.domains.every(d => domains.includes(d))) {
            this.ns.showWarnMessage(this.dic.ERRORS.authValidDomains);
            return;
        }

        this.integrationActionInProcess = true;

        this.authService.parseOpenIDMetadata(openIDData, err => {
            if (err) {
				this.ngZone.run(() => {
					this.integrationActionInProcess = false;
					this.ns.showErrorMessage('OIDC integration is invalid. '+err);
					return;
				});
            }

            this.authService.validateOpenID(openIDData, this.userInfo.email, err => {
                if (err) {
                    this.integrationActionInProcess = false;
                    if (err !== true) {
						this.ngZone.run(() => {
							this.ns.showErrorMessage('OIDC integration is invalid. '+err);
						});
                    }
                    return;
                }

                this.rs.connectOpenID(openIDData).then(response => {
                    this.planInfo.integrations = this.planInfo.integrations || {};
                    this.planInfo.integrations.openid = openIDData;
                    this.planInfo.integrations.openid.enabled = true;
					this.integrationsAuthData[this.dic.CONSTANTS.integrationType.openid].enabled = true;
                    this.integrationActionInProcess = false;

					this.ngZone.run(() => {
						this.ns.showInfoMessage('Successfully connected to OIDC');
						this.openIDConfigPopup = null;
					});
                }, (err) => {
                    this.integrationActionInProcess = false;

					this.ngZone.run(() => {
						this.ns.showErrorMessage('OIDC integration is invalid. ' + err.data.message);
					});
                });
            });
        });
    }

    connectSamlExecute() {
        /*validation*/
        if (!this.samlConfigPopup.samlMetadata) { this.ns.showWarnMessage(this.dic.ERRORS.authSAMLMissing); return;}
        if (!this.samlConfigPopup.samlDomainsStr) { this.ns.showWarnMessage(util.format(this.dic.ERRORS.emptyField, "Domains")); return;}

        const samlData = {
            metadata: this.samlConfigPopup.samlMetadata,
            domains: this.samlConfigPopup.samlDomainsStr.split(',').map(itm => itm.trim())
        };

        if (samlData.domains.some(itm => !itm.match(DICTIONARY.CONSTANTS.DOMAIN_REGEX))) {
            this.ns.showWarnMessage(this.dic.ERRORS.authDomainFieldInvalid);
            return;
        }
        let domains = this.planInfo.domains && this.planInfo.domains.filter(d => d.verified).map(d => d.domain) || [];
        if (this.planInfo.exchange_server.enabled && this.planInfo.exchange_server.verified_domains) {
            domains = domains.concat(this.planInfo.exchange_server.verified_domains);
        }
        if (this.planInfo.gsuite_server.enabled && this.planInfo.gsuite_server.verified_domains) {
            domains = domains.concat(this.planInfo.gsuite_server.verified_domains);
        }
        if (domains.length && !samlData.domains.every(d => domains.includes(d))) {
            this.ns.showWarnMessage(this.dic.ERRORS.authValidDomains);
            return;
        }

        this.integrationActionInProcess = true;

        this.authService.parseSamlMetadata(samlData, err => {
            if (err) {
				this.ngZone.run(() => {
					this.integrationActionInProcess = false;
					this.ns.showErrorMessage('SAML integration is invalid. ' + err);
				});
                return;
            }

            this.authService.validateSaml(samlData, this.userInfo.email, err => {
                if (err) {
                    this.integrationActionInProcess = false;
                    if (err !== true) {
						this.ngZone.run(() => {
							this.ns.showErrorMessage('SAML integration is invalid. ' + err);
						});
                    }
                    return;
                }

                this.rs.connectSaml(samlData).then(response => {
                    this.planInfo.integrations = this.planInfo.integrations || {};
                    this.planInfo.integrations.saml = samlData;
                    this.planInfo.integrations.saml.enabled = true;
					this.integrationsAuthData[this.dic.CONSTANTS.integrationType.saml].enabled = true;
                    this.integrationActionInProcess = false;

					this.ngZone.run(() => {
						this.samlConfigPopup = null;
						this.ns.showInfoMessage('Successfully connected to SAML');
					});
                }, (err) => {
                    this.integrationActionInProcess = false;

					this.ngZone.run(() => {
						this.ns.showErrorMessage('SAML integration is invalid. ' + err.data.message);
					});
                });
            });
        });
    }

    connectToS3() {
        if (this.integrationsSecurityData[this.dic.CONSTANTS.integrationType.s3].enabled) {
            this.gs.showPopup({
                title: 'Disconnect from Amazon S3',
                subTitle: `Please note - you are about to cancel the connection to your Amazon S3 client`,
                body: [],
                type: this.dic.CONSTANTS.popupWarning,
                doneBtnText: 'Disconnect',
                doneCb: () => {
                    this.integrationActionInProcess = true;

                    const actionInfo = {
                        action: this.dic.CONSTANTS.integrationActions.disable
                    }
                    this.integrationActionInProcess = true;
                    this.rs.configureS3Integration(actionInfo).then((response) => {
                        this.ns.showInfoMessage( 'Successfully disconnected from Amazon S3');
                        this.integrationActionInProcess = false;
                        this.planInfo.integrations.s3 = {enabled: false};
						this.integrationsSecurityData[this.dic.CONSTANTS.integrationType.s3].enabled = false;
                    }, err => {
                        this.integrationActionInProcess = false;
                    });
                }
            });
        }
        else {
            this.S3ConnectPopup = {
                remote_account_id: '',
                remote_role: '',
                use_predefined_sse: '',
                attachments: '',
                content: '',
                archiving: '',
                show: true
            };
        }
    };

    validateS3() {
        return this.S3ConnectPopup.remote_account_id && this.S3ConnectPopup.remote_role;
    }

    connectS3Execute() {
        if (!this.validateS3()) {
            return;
        }

        this.integrationActionInProcess = true;

        const actionInfo = {
            action: this.dic.CONSTANTS.integrationActions.enable,
            remote_account_id: this.S3ConnectPopup.remote_account_id,
            remote_role: this.S3ConnectPopup.remote_role,
            use_predefined_sse: this.S3ConnectPopup.use_predefined_sse,
            attachments: this.S3ConnectPopup.attachments,
            content: this.S3ConnectPopup.content,
            archiving: this.S3ConnectPopup.archiving,
        }
        this.integrationActionInProcess = true;
        this.rs.configureS3Integration(actionInfo).then((response) => {
            this.S3ConnectPopup = null;
            this.ns.showInfoMessage('Successfully enabled Amazon S3 integration');
            this.planInfo.integrations.s3 = response.s3;
			this.integrationsSecurityData[this.dic.CONSTANTS.integrationType.s3].enabled = true;
            this.integrationActionInProcess = false;
        }, (err) => {
            if (err && err.data && err.data.message && !err.data.display_bar) {
                this.ns.showErrorMessage(err.data.message);
            }
            this.integrationActionInProcess = false;
        });
    };

	connectToSyslog() {
		if (this.integrationsSiemData[this.dic.CONSTANTS.integrationType.syslog].enabled) {
			this.gs.showPopup({
				title: 'Disconnect from Syslog',
				subTitle: `Please note - you are about to cancel the connection to your Syslog server`,
				body: ["Logs will not be sent to your syslog"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureSyslogIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.integrationsSiemData[this.dic.CONSTANTS.integrationType.syslog].enabled = false;
						this.ns.showInfoMessage( 'Successfully disconnected from Syslog server');

						this.planInfo.integrations.syslog = {
							enabled: false
						};
					},(err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.syslogConnectPopup = {
				host: '',
				port: 514,
				protocol: 'tcp',
				show: true
			};
		}
	}

	connectSyslogExecute() {
		if (!this.syslogConnectPopup.host || !this.syslogConnectPopup.port) {
			return;
		}

		this.integrationActionInProcess = true;

		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			host: this.syslogConnectPopup.host.trim(),
			port: this.syslogConnectPopup.port,
			protocol: this.syslogConnectPopup.protocol,
		};
		this.rs.configureSyslogIntegration(syslogInfo).then(response => {
			this.syslogConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to Syslog server');

			this.planInfo.integrations.syslog = syslogInfo;
			this.planInfo.integrations.syslog.enabled = true;
			this.integrationsSiemData[this.dic.CONSTANTS.integrationType.syslog].enabled = true;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

	connectToConnectWise() {
		if (this.planInfo.integrations.connectWise?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from ConnectWise',
				subTitle: `Please note - you are about to cancel the connection to your ConnectWise server`,
				body: ["Logs will not be sent to your ConnectWise"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureConnectWiseIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage('Successfully disconnected from ConnectWise server');

						this.planInfo.integrations.connectWise = {
							enabled: false
						};
						this.integrationsPsaData[this.dic.CONSTANTS.integrationType.connectWise].enabled = false;
					}, (err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.connectWiseConnectPopup = {
				show: true
			};
		}
	}

	connectToConnectWiseExecute() {
		if (this.integrationActionInProcess) {
			return;
		}

		if (!this.connectWiseConnectPopup.tenant || !this.connectWiseConnectPopup.client_id || !this.connectWiseConnectPopup.client_secret
			|| !this.connectWiseConnectPopup.auth_server || !this.connectWiseConnectPopup.resource_server || !this.connectWiseConnectPopup.category) {
			return;
		}

		this.integrationActionInProcess = true;

		const integrationInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			tenant: this.connectWiseConnectPopup.tenant.trim(),
			client_id: this.connectWiseConnectPopup.client_id.trim(),
			client_secret: this.connectWiseConnectPopup.client_secret.trim(),
			auth_server: this.connectWiseConnectPopup.auth_server.trim(),
			resource_server: this.connectWiseConnectPopup.resource_server.trim(),
			category: this.connectWiseConnectPopup.category.trim(),
			ticketType: this.connectWiseConnectPopup.ticketType?.trim()
		};
		this.rs.configureConnectWiseIntegration(integrationInfo).then(response => {
			this.connectWiseConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to ConnectWise server');

			this.planInfo.integrations.connectWise = integrationInfo;
			this.planInfo.integrations.connectWise.enabled = true;
			this.integrationsPsaData[this.dic.CONSTANTS.integrationType.connectWise].enabled = true;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

	// CC: taken from integrations.component.ts -> connectToConnectWise
	connectToAutotask() {
		if (this.planInfo.integrations.autoTask?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from Autotask',
				subTitle: `Please note - you are about to cancel the connection to your Autotask server`,
				body: ["Logs will not be sent to your Autotask"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureAutotaskIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage('Successfully disconnected from Autotask server');

						this.planInfo.integrations.autoTask = {
							enabled: false
						};
						this.integrationsPsaData[this.dic.CONSTANTS.integrationType.autotask].enabled = false;
					}, (err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.autotaskConnectPopup = {
				show: true,
				company_id: 0
			};
		}
	}

	connectToAutotaskExecute() {
		if (this.integrationActionInProcess) {
			return;
		}

		if (!this.autotaskConnectPopup.username || !this.autotaskConnectPopup.secret || !this.autotaskConnectPopup.integration_code
			|| !this.autotaskConnectPopup.queue_id) {
			return;
		}

		this.integrationActionInProcess = true;

		const integrationInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			username: this.autotaskConnectPopup.username.trim(),
			secret: this.autotaskConnectPopup.secret.trim(),
			integration_code: this.autotaskConnectPopup.integration_code.trim(),
			company_id: this.autotaskConnectPopup.company_id,
			queue_id: this.autotaskConnectPopup.queue_id
		};
		this.rs.configureAutotaskIntegration(integrationInfo).then(response => {
			this.autotaskConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to Autotask server');

			this.planInfo.integrations.autoTask = integrationInfo;
			this.planInfo.integrations.autoTask.enabled = true;
			this.integrationsPsaData[this.dic.CONSTANTS.integrationType.autotask].enabled = true;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

	// CC: taken from integrations.component.ts -> connectToAutotask
	connectToSuperOps() {
		if (this.planInfo.integrations.superOps?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from SuperOps',
				subTitle: `Please note - you are about to cancel the connection to your SuperOps server`,
				body: ["Logs will not be sent to your SuperOps"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureSuperOpsIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage('Successfully disconnected from SuperOps server');

						this.planInfo.integrations.superOps = {
							enabled: false
						};
						this.integrationsPsaData[this.dic.CONSTANTS.integrationType.superOps].enabled = false;
					}, (err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.superOpsConnectPopup = {
				show: true,
				data_center: 'us',
			};
		}
	}

	connectToSuperOpsExecute() {
		if (this.integrationActionInProcess) {
			return;
		}

		if (!this.superOpsConnectPopup.subdomain || !this.superOpsConnectPopup.api_token) {
			return;
		}

		this.integrationActionInProcess = true;

		const integrationInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			subdomain: this.superOpsConnectPopup.subdomain.trim(),
			api_token: this.superOpsConnectPopup.api_token.trim(),
			data_center: this.superOpsConnectPopup.data_center
		};
		this.rs.configureSuperOpsIntegration(integrationInfo).then(response => {
			this.superOpsConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to SuperOps server');

			this.planInfo.integrations.superOps = integrationInfo;
			this.planInfo.integrations.superOps.enabled = true;
			this.integrationsPsaData[this.dic.CONSTANTS.integrationType.superOps].enabled = true;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err?.data?.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

	connectToHaloPsa() {
		if (this.planInfo.integrations.haloPSA?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from Halo PSA',
				subTitle: `Please note - you are about to cancel the connection to your Halo PSA server`,
				body: ["Logs will not be sent to your Halo PSA"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureHaloPsaIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage('Successfully disconnected from Halo PSA server');

						this.planInfo.integrations.haloPSA = {
							enabled: false
						};
						this.integrationsPsaData[this.dic.CONSTANTS.integrationType.haloPSA].enabled = false;
					}, (err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.haloPSAConnectPopup = {
				token: '',
				resource_domain: 'usehalo.com', // CC: default value for Halo PSA resource domain
				show: true
			};
		}
	}

	connectToHaloPsaExecute() {
		if (this.integrationActionInProcess) {
			return;
		}

		if (!this.haloPSAConnectPopup.tenant || !this.haloPSAConnectPopup.client_id || !this.haloPSAConnectPopup.client_secret) {
			return;
		}

		this.integrationActionInProcess = true;

		const integrationInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			tenant: this.haloPSAConnectPopup.tenant.trim(),
			client_id: this.haloPSAConnectPopup.client_id.trim(),
			client_secret: this.haloPSAConnectPopup.client_secret.trim(),
			category: this.haloPSAConnectPopup.category?.trim(),
			ticketType: this.haloPSAConnectPopup.ticketType?.trim(),
			resource_domain: this.haloPSAConnectPopup.resource_domain?.trim() // CC: added resource_domain field
		};
		this.rs.configureHaloPsaIntegration(integrationInfo).then(response => {
			this.haloPSAConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to Halo PSA server');

			this.planInfo.integrations.haloPSA = integrationInfo;
			this.planInfo.integrations.haloPSA.enabled = true;
			this.integrationsPsaData[this.dic.CONSTANTS.integrationType.haloPSA].enabled = true;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

	connectToHunters() {
		if (this.planInfo.integrations.huntress?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from Huntress',
				subTitle: `Please note - you are about to cancel the connection to your Huntress server`,
				body: ["Logs will not be sent to your Huntress"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureHuntersIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage('Successfully disconnected from Huntress server');

						this.planInfo.integrations.huntress = {
							enabled: false
						};
						this.integrationsSiemData[this.dic.CONSTANTS.integrationType.huntress].enabled = false;
					}, (err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.huntersConnectPopup = {
				token: '',
				show: true
			};
		}
	}

	connectToHuntersExecute() {
		if (!this.huntersConnectPopup.token) {
			return;
		}

		this.integrationActionInProcess = true;

		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			token: this.huntersConnectPopup.token.trim()
		};
		this.rs.configureHuntersIntegration(syslogInfo).then(response => {
			this.huntersConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to Huntress server');

			this.planInfo.integrations.huntress = syslogInfo;
			this.planInfo.integrations.huntress.enabled = true;
			this.integrationsSiemData[this.dic.CONSTANTS.integrationType.huntress].enabled = true;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};


	connectToCrowdStrike() {
		if (this.planInfo.integrations.crowd_strike?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from CrowdStrike',
				subTitle: `Please note - you are about to cancel the connection to your CrowdStrike server`,
				body: ["Logs will not be sent to your CrowdStrike"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureCrowdStrikeIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage('Successfully disconnected from CrowdStrike server');

						this.planInfo.integrations.crowd_strike = {
							enabled: false
						};
						this.integrationsSiemData[this.dic.CONSTANTS.integrationType.crowdStrike].enabled = false;
					}, (err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.crowdStrikeConnectPopup = {
				http_host: '',
				show: true
			};
		}
	}

	connectCrowdStrikeExecute() {
		if (!this.crowdStrikeConnectPopup.host || !this.crowdStrikeConnectPopup.token) {
			return;
		}

		this.integrationActionInProcess = true;

		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			host: this.crowdStrikeConnectPopup.host.trim(),
			token: this.crowdStrikeConnectPopup.token.trim()
		};
		this.rs.configureCrowdStrikeIntegration(syslogInfo).then(response => {
			this.crowdStrikeConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to CrowdStrike server');

			this.planInfo.integrations.crowd_strike = syslogInfo;
			this.planInfo.integrations.crowd_strike.enabled = true;
			this.integrationsSiemData[this.dic.CONSTANTS.integrationType.crowdStrike].enabled = true;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

	connectToRapid7() {
		if (this.planInfo.integrations.rapid7?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from Rapid7',
				subTitle: `Please note - you are about to cancel the connection to your Rapid7 server`,
				body: ["Logs will not be sent to your Rapid7"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureRapid7Integration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage('Successfully disconnected from Rapid7 server');

						this.planInfo.integrations.rapid7 = {
							enabled: false
						};
						this.integrationsSiemData[this.dic.CONSTANTS.integrationType.rapid7].enabled = false;
					}, (err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.rapid7ConnectPopup = {
				http_host: '',
				show: true
			};
		}
	}

	connectRapid7Execute() {
		if (!this.rapid7ConnectPopup.host) {
			return;
		}

		this.integrationActionInProcess = true;

		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			host: this.rapid7ConnectPopup.host.trim()
		};
		this.rs.configureRapid7Integration(syslogInfo).then(response => {
			this.rapid7ConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to Rapid7 server');

			this.planInfo.integrations.rapid7 = syslogInfo;
			this.planInfo.integrations.rapid7.enabled = true;
			this.integrationsSiemData[this.dic.CONSTANTS.integrationType.rapid7].enabled = true;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};


	connectToSumoLogic() {
		if (this.planInfo.integrations.sumo_logic?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from Sumo Logic',
				subTitle: `Please note - you are about to cancel the connection to your Sumo Logic server`,
				body: ["Logs will not be sent to your Sumo Logic"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureSumoLogicIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage('Successfully disconnected from Sumo Logic server');

						this.planInfo.integrations.sumo_logic = {
							enabled: false
						};
						this.integrationsSiemData[this.dic.CONSTANTS.integrationType.sumoLogic].enabled = false;
					}, (err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		} else {
			this.sumoLogicConnectPopup = {
				http_host: '',
				show: true
			};
		}
	}

	connectSumoLogicExecute() {
		if (!this.sumoLogicConnectPopup.http_host) {
			return;
		}

		this.integrationActionInProcess = true;

		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			http_host: this.sumoLogicConnectPopup.http_host.trim()
		};
		this.rs.configureSumoLogicIntegration(syslogInfo).then(response => {
			this.sumoLogicConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to Sumo Logic server');

			this.planInfo.integrations.sumo_logic = syslogInfo;
			this.planInfo.integrations.sumo_logic.enabled = true;
			this.integrationsSiemData[this.dic.CONSTANTS.integrationType.sumoLogic].enabled = this.planInfo.integrations.sumo_logic.enabled;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};


	connectToSentinelOne() {
		if (this.planInfo.integrations.sentinel_one?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from SentinelOne',
				subTitle: `Please note - you are about to cancel the connection to your SentinelOne server`,
				body: ["Logs will not be sent to your SentinelOne"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureSentinelOneIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage('Successfully disconnected from SentinelOne server');

						this.planInfo.integrations.sentinel_one = {
							enabled: false
						};
						this.integrationsSiemData[this.dic.CONSTANTS.integrationType.sentinelOne].enabled = false;
					}, (err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		} else {
			this.sentinelOneConnectPopup = {
				host: '',
				token: '',
				show: true
			};
		}
	}

	connectSentinelOneExecute() {
		if (!this.sentinelOneConnectPopup.host || !this.sentinelOneConnectPopup.token) {
			return;
		}

		this.integrationActionInProcess = true;

		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			host: this.sentinelOneConnectPopup.host.trim(),
			token: this.sentinelOneConnectPopup.token.trim()
		};
		this.rs.configureSentinelOneIntegration(syslogInfo).then(response => {
			this.sentinelOneConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to SentinelOne server');

			this.planInfo.integrations.sentinel_one = syslogInfo;
			this.planInfo.integrations.sentinel_one.enabled = true;
			this.integrationsSiemData[this.dic.CONSTANTS.integrationType.sentinelOne].enabled = this.planInfo.integrations.sentinel_one.enabled;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

	connectToXsiam() {
		if (this.planInfo.integrations.xsiam?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from Cortex XSIAM',
				subTitle: `Please note - you are about to cancel the connection to your Cortex XSIAM server`,
				body: ["Logs will not be sent to your Cortex XSIAM"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureXsiamIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage('Successfully disconnected from Cortex XSIAM server');

						this.planInfo.integrations.xsiam = {
							enabled: false
						};
						this.setIntegrationEnabled(this.integrationsSiemData, this.dic.CONSTANTS.integrationType.xsiam, false);
					}, (err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		} else {
			this.xsiamConnectPopup = {
				host: '',
				token: '',
				show: true
			};
		}
	}

	connectXsiamExecute() {
		if (!this.xsiamConnectPopup.host || !this.xsiamConnectPopup.token) {
			return;
		}

		this.integrationActionInProcess = true;

		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			host: this.xsiamConnectPopup.host.trim(),
			token: this.xsiamConnectPopup.token.trim()
		};
		this.rs.configureXsiamIntegration(syslogInfo).then(response => {
			this.xsiamConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to XSIAM server');

			this.planInfo.integrations.xsiam = syslogInfo;
			this.planInfo.integrations.xsiam.enabled = true;
			this.setIntegrationEnabled(this.integrationsSiemData, this.dic.CONSTANTS.integrationType.xsiam, this.planInfo.integrations.xsiam.enabled);

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

	connectToSplunk() {
		if (this.planInfo.integrations.splunk?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from Splunk',
				subTitle: `Please note - you are about to cancel the connection to your Splunk server`,
				body: ["Logs will not be sent to your Splunk"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureSplunkIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage( 'Successfully disconnected from Splunk server');

						this.planInfo.integrations.splunk = {
							enabled: false
						};
						this.integrationsSiemData[this.dic.CONSTANTS.integrationType.splunk].enabled = false;
					},(err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.splunkConnectPopup = {
				host: '',
				token: '',
				show: true
			};
		}
	}

	connectSplunkExecute() {
		if (!this.splunkConnectPopup.host || !this.splunkConnectPopup.token) {
			return;
		}

		this.integrationActionInProcess = true;

		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			host: this.splunkConnectPopup.host.trim(),
			token: this.splunkConnectPopup.token.trim()
		};
		this.rs.configureSplunkIntegration(syslogInfo).then(response => {
			this.splunkConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to Splunk server');

			this.planInfo.integrations.splunk = syslogInfo;
			this.planInfo.integrations.splunk.enabled = true;
			this.integrationsSiemData[this.dic.CONSTANTS.integrationType.splunk].enabled = this.planInfo.integrations.splunk.enabled;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

	// CC: taken from integrations.component.ts -> connectToSplunk
	connectToQradar() {
		if (this.planInfo.integrations.qradar?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from QRadar',
				subTitle: `Please note - you are about to cancel the connection to your QRadar server`,
				body: ["Logs will not be sent to your QRadar"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureQradarIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage( 'Successfully disconnected from QRadar server');

						this.planInfo.integrations.qradar = {
							enabled: false
						};
						this.integrationsSiemData[this.dic.CONSTANTS.integrationType.qradar].enabled = false;
					},(err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.qradarConnectPopup = {
				host: '',
				token: '',
				show: true
			};
		}
	}

	// CC: taken from integrations.component.ts -> connectSplunkExecute
	connectQradarExecute() {
		if (!this.qradarConnectPopup.host || !this.qradarConnectPopup.token) {
			return;
		}

		this.integrationActionInProcess = true;

		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			host: this.qradarConnectPopup.host.trim(),
			token: this.qradarConnectPopup.token.trim()
		};
		this.rs.configureQradarIntegration(syslogInfo).then(response => {
			this.qradarConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to QRadar server');

			this.planInfo.integrations.qradar = syslogInfo;
			this.planInfo.integrations.qradar.enabled = true;
			this.integrationsSiemData[this.dic.CONSTANTS.integrationType.qradar].enabled = this.planInfo.integrations.qradar.enabled;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

	// CC: taken from integrations.component.ts -> connectToQradar
	connectToGraylog() {
		if (this.planInfo.integrations.graylog?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from Graylog',
				subTitle: `Please note - you are about to cancel the connection to your Graylog server`,
				body: ["Logs will not be sent to your Graylog"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureGraylogIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage( 'Successfully disconnected from Graylog server');

						this.planInfo.integrations.graylog = {
							enabled: false
						};
						this.integrationsSiemData[this.dic.CONSTANTS.integrationType.graylog].enabled = false;
					},(err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.graylogConnectPopup = {
				host: '',
				port: 12201,
				token: '',
				show: true
			};
		}
	}

	// CC: taken from integrations.component.ts -> connectQradarExecute
	connectGraylogExecute() {
		if (!this.graylogConnectPopup.host || !this.graylogConnectPopup.port) {
			return;
		}

		this.integrationActionInProcess = true;

		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			host: this.graylogConnectPopup.host.trim(),
			port: this.graylogConnectPopup.port,
			// CC: token is optional - the GELF HTTP input may have no Authorization Header Value set
			token: this.graylogConnectPopup.token?.trim() || ''
		};
		this.rs.configureGraylogIntegration(syslogInfo).then(response => {
			this.graylogConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to Graylog server');

			this.planInfo.integrations.graylog = syslogInfo;
			this.planInfo.integrations.graylog.enabled = true;
			this.integrationsSiemData[this.dic.CONSTANTS.integrationType.graylog].enabled = this.planInfo.integrations.graylog.enabled;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

	connectToAzureEventHub() {
		if (this.planInfo.integrations.eventhub?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from Azure EventHub',
				subTitle: `Please note - you are about to cancel the connection to your Azure EventHub server`,
				body: ["Logs will not be sent to your Azure EventHub"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureAzureEventHubIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage( 'Successfully disconnected from Azure EventHub server');

						this.planInfo.integrations.eventhub = {
							enabled: false
						};
						this.integrationsSiemData[this.dic.CONSTANTS.integrationType.eventhub].enabled = false;
					},(err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.azureEventHubConnectPopup = {
				connection: '',
				namespace: '',
				hub_name: '',
				key_name: '',
				key_secret: '',
				show: true
			};
		}
	}

	connectToAzureEventHubExecute() {
		if (this.azureEventHubConnectPopup.connection) {
			this.azureEventHubConnectPopup.connection = decodeURIComponent(this.azureEventHubConnectPopup.connection);

			//"Endpoint=sb://<YourNamespace>.servicebus.windows.net/;SharedAccessKeyName=<KeyName>;SharedAccessKey=<Key>;EntityPath=<YourEventHub>"
			const match = this.azureEventHubConnectPopup.connection.match(/Endpoint=sb:\/\/(.+)\.servicebus\.windows\.net\/?;SharedAccessKeyName=(.+);SharedAccessKey=(.+);EntityPath=(.+)/i);
			if (match) {
				this.azureEventHubConnectPopup.namespace = match[1];
				this.azureEventHubConnectPopup.key_name = match[2];
				this.azureEventHubConnectPopup.key_secret = match[3];
				this.azureEventHubConnectPopup.hub_name = match[4];
			}
		}

		if (!this.azureEventHubConnectPopup.namespace || !this.azureEventHubConnectPopup.hub_name || !this.azureEventHubConnectPopup.key_name || !this.azureEventHubConnectPopup.key_secret) {
			this.ns.showErrorMessage('Azure EventHub verification failed: Could not establish connection, please verify the provided connection string');
			return;
		}

		this.integrationActionInProcess = true;

		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			namespace: this.azureEventHubConnectPopup.namespace.trim(),
			hub_name: this.azureEventHubConnectPopup.hub_name.trim(),
			key_name: this.azureEventHubConnectPopup.key_name.trim(),
			key_secret: this.azureEventHubConnectPopup.key_secret.trim()
		};
		this.rs.configureAzureEventHubIntegration(syslogInfo).then(response => {
			this.azureEventHubConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to Azure EventHub');

			this.planInfo.integrations.eventhub = syslogInfo;
			this.planInfo.integrations.eventhub.enabled = true;
			this.integrationsSiemData[this.dic.CONSTANTS.integrationType.eventhub].enabled = this.planInfo.integrations.eventhub.enabled;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

	// CC: taken from integrations.component.ts -> connectToAzureEventHub
	connectToMicrosoftSentinel() {
		if (this.planInfo.integrations.microsoft_sentinel?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from Microsoft Sentinel',
				subTitle: `Please note - you are about to cancel the connection to your Microsoft Sentinel server`,
				body: ["Logs will not be sent to your Microsoft Sentinel"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureMicrosoftSentinelIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage('Successfully disconnected from Microsoft Sentinel server');

						this.planInfo.integrations.microsoft_sentinel = {
							enabled: false
						};
						this.integrationsSiemData[this.dic.CONSTANTS.integrationType.microsoftSentinel].enabled = false;
					},(err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.microsoftSentinelConnectPopup = {
				host: '',
				tenant_id: '',
				client_id: '',
				client_secret: '',
				dcr_id: '',
				stream_name: '',
				show: true
			};
		}
	}

	// CC: taken from integrations.component.ts -> connectToAzureEventHubExecute
	connectMicrosoftSentinelExecute() {
		if (!this.microsoftSentinelConnectPopup.host || !this.microsoftSentinelConnectPopup.tenant_id || !this.microsoftSentinelConnectPopup.client_id || !this.microsoftSentinelConnectPopup.client_secret) {
			return;
		}

		this.integrationActionInProcess = true;

		const syslogInfo = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			host: this.microsoftSentinelConnectPopup.host.trim(),
			tenant_id: this.microsoftSentinelConnectPopup.tenant_id.trim(),
			dcr_id: this.microsoftSentinelConnectPopup.dcr_id.trim(),
			stream_name: this.microsoftSentinelConnectPopup.stream_name.trim(),
			client_id: this.microsoftSentinelConnectPopup.client_id.trim(),
			client_secret: this.microsoftSentinelConnectPopup.client_secret.trim()
		};
		this.rs.configureMicrosoftSentinelIntegration(syslogInfo).then(response => {
			this.microsoftSentinelConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to Microsoft Sentinel');

			this.planInfo.integrations.microsoft_sentinel = syslogInfo;
			this.planInfo.integrations.microsoft_sentinel.enabled = true;
			this.integrationsSiemData[this.dic.CONSTANTS.integrationType.microsoftSentinel].enabled = this.planInfo.integrations.microsoft_sentinel.enabled;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

	// CC: taken from integrations.component.ts -> connectToCrowdStrike
	connectToStellarCyber() {
		if (this.planInfo.integrations.stellar_cyber?.enabled) {
			this.gs.showPopup({
				title: 'Disconnect from Stellar Cyber',
				subTitle: `Please note - you are about to cancel the connection to your Stellar Cyber server`,
				body: ["Logs will not be sent to your Stellar Cyber"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					const syslogInfo = {
						action: this.dic.CONSTANTS.integrationActions.disable,
					};
					this.rs.configureStellarCyberIntegration(syslogInfo).then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage('Successfully disconnected from Stellar Cyber server');

						this.planInfo.integrations.stellar_cyber = {
							enabled: false
						};
						this.integrationsSiemData[this.dic.CONSTANTS.integrationType.stellarCyber].enabled = false;
					}, (err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.stellarCyberConnectPopup = {
				show: true
			};
		}
	}

	connectStellarCyberExecute() {
		if (!this.stellarCyberConnectPopup.host || !this.stellarCyberConnectPopup.api_key) {
			return;
		}

		this.integrationActionInProcess = true;

		const syslogInfo: any = {
			action: this.dic.CONSTANTS.integrationActions.enable,
			host: this.stellarCyberConnectPopup.host.trim(),
			api_key: this.stellarCyberConnectPopup.api_key.trim()
		};
		if (this.stellarCyberConnectPopup.username?.trim()) {
			syslogInfo.username = this.stellarCyberConnectPopup.username.trim();
		}
		this.rs.configureStellarCyberIntegration(syslogInfo).then(response => {
			this.stellarCyberConnectPopup = false;
			this.ns.showInfoMessage('Successfully connected to Stellar Cyber server');

			this.planInfo.integrations.stellar_cyber = syslogInfo;
			this.planInfo.integrations.stellar_cyber.enabled = true;
			this.integrationsSiemData[this.dic.CONSTANTS.integrationType.stellarCyber].enabled = true;

			this.integrationActionInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.integrationActionInProcess = false;
		});
	};

    integImportGroups() {
        if (!this.selectedIntegrationObj.enabled) {
            this.integrationActionInProcess = false;
            return;
        }
        this.integrationActionInProcess = true;

        let promise;
        switch (this.selectedIntegrationObj.name) {
            case this.dic.CONSTANTS.integrationType.exchange:
                promise = this.rs.createGroupSubscription();
                break;

            case this.dic.CONSTANTS.integrationType.gsuite:
                promise = this.rs.createGSuiteGroups();
                break;
        }

        promise.then(groups => {
            this.ns.showInfoMessage('We are updating information from your mail server, this process may take several minutes to finish');
            this.integrationActionInProcess = false;
        },(err) => {
            this.integrationActionInProcess = false;
        });
    };

    getMailboxesAliases = (show) => {
        this.showAliases = show;
    };

    getGroups = (show) => {
        this.showGroups = show;
    };

    changeEndpoint = (endpoint) => {
        if (this.integrationActionInProcess || this.selectedServerEndpoint.name === endpoint.name) return;

		let azureADInput = endpoint.AzureAD;
		let microsoftGraphAPIInput = endpoint.MSGraphAPI;
		let axoAdminAPIInput = endpoint.ExoAdminAPI;
        if (endpoint.name === this.dic.CONSTANTS.exchangeServerEndpoints.Hybrid.name) {
			azureADInput = '';
			microsoftGraphAPIInput = '';
			axoAdminAPIInput = '';
        }

		this.changeEndPointPopup = {
			show: true,
			applyInProcess: false,
			subTitle: `Please note - you are about to change the cloud API endpoint of your mail server to ${endpoint.name}`,
			azureADInput: azureADInput,
			microsoftGraphAPIInput: microsoftGraphAPIInput,
			axoAdminAPIInput: axoAdminAPIInput,
			doneCb: () => {
				this.changeEndPointPopup.applyInProcess = true;
				if (this.changeEndPointPopup.azureADInput !== undefined && this.changeEndPointPopup.microsoftGraphAPIInput !== undefined) {
					if (this.changeEndPointPopup.azureADInput === ""|| this.changeEndPointPopup.microsoftGraphAPIInput === "") {
						this.changeEndPointPopup.applyInProcess = false;
						return this.ns.showErrorMessage("Please enter a valid endpoint");
					}

					if (this.changeEndPointPopup.azureADInput.indexOf(' ') > -1 || this.changeEndPointPopup.microsoftGraphAPIInput.indexOf(' ') > -1) {
						this.changeEndPointPopup.applyInProcess = false;
						return this.ns.showErrorMessage(this.dic.ERRORS.invalidServerEndpoint);
					}
					this.selectedServerEndpoint.AzureAD = this.changeEndPointPopup.azureADInput;
					this.selectedServerEndpoint.MSGraphAPI = this.changeEndPointPopup.microsoftGraphAPIInput;
					this.selectedServerEndpoint.ExoAdminAPI = this.changeEndPointPopup.axoAdminAPIInput;
				}
				this.selectedServerEndpoint.name = endpoint.name;
				this.updateCloudAPIEndpoint();
			}
		};
    };

    updateCloudAPIEndpoint = () => {
        if (!this.selectedServerEndpoint.name || !this.selectedServerEndpoint.AzureAD || !this.selectedServerEndpoint.MSGraphAPI || !this.selectedServerEndpoint.ExoAdminAPI) return;

        this.integrationActionInProcess = true;
        this.rs.activateInboundEmailRelayAndGenKey({
            action: this.dic.CONSTANTS.inboundRelayActions.cloudAPIEndpoint,
            endpoint: this.selectedServerEndpoint
        }).then(() => {
            this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);
            this.planInfo.exchange_server.endpoint_name = this.selectedServerEndpoint.name;
            this.integrationActionInProcess = false;
			this.changeEndPointPopup.show = false;
        }, () => {
            this.integrationActionInProcess = false;
            this.changeEndPointPopup.applyInProcess = false;
            this.changeEndPointPopup.show = false;
        });
    };

    verifyCheckPointIntegration = (clientId, accessKey) => {
        const actionInfo = {
            action: this.dic.CONSTANTS.integrationActions.verifyToken,
            clientId: clientId,
            accessKey: accessKey
        }
        this.integrationActionInProcess = true;
        this.rs.configureCheckpoint(actionInfo).then((response) => {
            this.integrationActionInProcess = false;
        }, err => {
            this.integrationActionInProcess = false;
        });
    };

    verifyS3Integration = () => {
        const actionInfo = {
            action: this.dic.CONSTANTS.integrationActions.verifyToken,
            use_predefined_sse: this.planInfo.integrations.s3.use_predefined_sse,
            remote_account_id: this.planInfo.integrations.s3.remote_account_id,
            remote_role: this.planInfo.integrations.s3.remote_role
        }
        this.integrationActionInProcess = true;
        this.rs.configureS3Integration(actionInfo).then((response) => {
            this.integrationActionInProcess = false;
        }, err => {
            this.integrationActionInProcess = false;
        });
    };

    verifyOpenIDIntegration = () => {
        this.integrationActionInProcess = true;
        this.authService.validateOpenID(this.planInfo.integrations.openid, this.userInfo.email, err => {
            if (err) {
                if (err !== true) {
                    this.ns.showErrorMessage('OIDC integration is invalid: ' + err);
                }
            }
            else {
                this.ns.showInfoMessage('Successfully connected to OIDC');
            }

            this.integrationActionInProcess = false;
        });
    };

    verifySamlIntegration = () => {
        this.integrationActionInProcess = true;
        this.authService.validateSaml(this.planInfo.integrations.saml, this.userInfo.email, err => {
            if (err) {
                if (err !== true) {
                    this.ns.showErrorMessage('SAML integration is invalid: ' + err);
                }
            }
            else {
                this.ns.showInfoMessage('Successfully connected to SAML');
            }

			this.ngZone.run(() => {
				this.integrationActionInProcess = false;
			});
        });
    };

	connectToPowershell() {
		if (this.integrationsEmailInfraData[this.dic.CONSTANTS.integrationType.powershell].enabled) {
			this.gs.showPopup({
				title: 'Disconnect from PowerShell',
				subTitle: `Please note - you are about to cancel the connection to your Exchange Server PowerShell`,
				body: ["You will not be able to do any powershell related operations"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					let disconnectFlow = this.planInfo.exchange_server?.exoadmin_enabled ? this.rs.disconnectExchange({onlyExoadmin:true}) : this.rs.exchangeDeviceDisconnect();
					disconnectFlow.then(() => {
						this.integrationActionInProcess = false;
						this.integrationsEmailInfraData[this.dic.CONSTANTS.integrationType.powershell].enabled = false;
						this.ns.showInfoMessage( 'Successfully disconnected from Exchange Server PowerShell');

						this.planInfo.powershell = {enabled: false};
						this.exchangePowershellPopup[this.exchangePowershellCommands.login] = null;
					},(err) => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.openExchangePowershellPopup(this.exchangePowershellCommands.login);
		}
	}

	closeExchangePowershellPopup(type:string, success:boolean, disconnected:boolean) {
		if (type === this.exchangePowershellCommands.login && success) {
			this.integrationsEmailInfraData[this.dic.CONSTANTS.integrationType.powershell].enabled = true;

			if (!this.planInfo.powershell.enabled) {
				this.planInfo.powershell = {enabled: true, refresh_token: true};
			}
			else {
				this.planInfo.powershell.refresh_token = true;
			}
		}

		if (disconnected) {
			this.planInfo.powershell.refresh_token = false;
			this.integrationsEmailInfraData[this.dic.CONSTANTS.integrationType.powershell].enabled = false;
		}

		this.exchangePowershellPopup[type] = null;
	}

	openPowershellAutoReleasePopup = () => {
		this.gs.showPopup({
			title: 'Release Quarantined Emails',
			subTitle: `All quarantined emails in Exchange will be released. This operation can take a few minutes.`,
			body: [],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Confirm',
			doneCb: () => {
				this.rs.powershellQuarantineAction('autoReleaseExecute', {enabled: this.planInfo.powershell.automatic_release}).then(res => {
					this.integrationActionInProcess = false;
					this.ns.showInfoMessage( 'Successfully called for release of quarantine emails');
				}, err => {
					this.integrationActionInProcess = false;
				});
			}
		});
	}

	openExchangePowershellPopup(type: string, source = null) {
		switch (type) {
			case this.exchangePowershellCommands.verify:
				this.integrationActionInProcess = true;
				this.rs.exchangeVerifyLogin().then(res => {
					this.integrationActionInProcess = false;
					this.ns.showInfoMessage('Successfully connected to Exchange Server PowerShell');
				}, err => {
					if (err.data && err.data.disconnected) {
						this.planInfo.powershell.refresh_token = false;
						this.integrationsEmailInfraData[this.dic.CONSTANTS.integrationType.powershell].enabled = false;
					}
					this.integrationActionInProcess = false;
				});
				return;

			case this.exchangePowershellCommands.enableSyncQuarantine:
				this.integrationActionInProcess = true;
				this.rs.powershellQuarantineAction('sync', {enabled: this.planInfo.powershell.sync_quarantine}).then(res => {
					this.integrationActionInProcess = false;
					this.ns.showInfoMessage('Successfully enabled synchronization to Exchange Server quarantined emails');
					if (!this.planInfo.powershell.sync_quarantine) {
						this.planInfo.powershell.automatic_release = false;
						this.planInfo.powershell.rescan_after_exchange_release = false;
					}
				}, err => {
					this.planInfo.powershell.sync_quarantine = !this.planInfo.powershell.sync_quarantine;
					this.integrationActionInProcess = false;
				});
				return;

			case this.exchangePowershellCommands.enableAutomaticRelease:
				this.integrationActionInProcess = true;
				this.rs.powershellQuarantineAction('autoRelease', {enabled: this.planInfo.powershell.automatic_release}).then(res => {
					this.integrationActionInProcess = false;
					this.ns.showInfoMessage(`Successfully ${this.planInfo.powershell.automatic_release ? 'enabled' : 'disabled'} Automatic Release`);

					if (!this.planInfo.powershell.automatic_release) {
						this.planInfo.powershell.rescan_after_exchange_release = false;
					}
				}, err => {
					this.planInfo.powershell.automatic_release = !this.planInfo.powershell.automatic_release;
					this.integrationActionInProcess = false;
				});
				return;

			case this.exchangePowershellCommands.autoReleaseForReScan:
				this.integrationActionInProcess = true;
				this.rs.powershellQuarantineAction(this.exchangePowershellCommands.autoReleaseForReScan, {enabled: this.planInfo.powershell.rescan_after_exchange_release}).then(res => {
					this.integrationActionInProcess = false;
					this.ns.showInfoMessage(`Successfully ${this.planInfo.powershell.rescan_after_exchange_release ? 'enabled' : 'disabled'} scan and release safe emails`);
				}, err => {
					this.planInfo.powershell.rescan_after_exchange_release = !this.planInfo.powershell.rescan_after_exchange_release;
					this.integrationActionInProcess = false;
				});
				return;

			case this.exchangePowershellCommands.junkRule:
				if (source === 'inbound' && !this.planInfo.inbound_relay?.enabled) {
					const url = this.gs.buildInternalUrl(`/${DICTIONARY.CONSTANTS.appStates.adminInbound}/${DICTIONARY.CONSTANTS.adminPages.inbound.plan}/${DICTIONARY.CONSTANTS.inboundPlanSettingsPageTabs.emailFlowIntegration}`);
					const message = util.format(DICTIONARY.ERRORS.wizardNoRelay,
						'Inbound',
						`<a target="_self" href="${url}"><b><i>Mail Flow Integration page</i></b></a>`);
					this.ns.showErrorMessage(message);
					return;
				}

				this.exchangePowershellPopup[type] = { show: true };
				break;

			case this.exchangePowershellCommands.rules:
				if (source === 'inbound' && !this.planInfo.inbound_relay?.enabled) {
					const url = this.gs.buildInternalUrl(`/${DICTIONARY.CONSTANTS.appStates.adminInbound}/${DICTIONARY.CONSTANTS.adminPages.inbound.plan}/${DICTIONARY.CONSTANTS.inboundPlanSettingsPageTabs.emailFlowIntegration}`);
					const message = util.format(DICTIONARY.ERRORS.wizardNoRelay,
						'Inbound',
						`<a target="_self" href="${url}"><b><i>Mail Flow Integration page</i></b></a>`);
					this.ns.showErrorMessage(message);
					return;
				}
				else {
					if (source === 'outbound' && !this.planInfo.outbound_relay?.enabled) {
						const url = this.gs.buildInternalUrl(`/${DICTIONARY.CONSTANTS.appStates.adminOutbound}/${DICTIONARY.CONSTANTS.adminPages.outbound.sharedPlan}/${DICTIONARY.CONSTANTS.outboundPlanSettingsPageTabs.emailFlowIntegration}`);
						const message = util.format(DICTIONARY.ERRORS.wizardNoRelay,
							'Outbound',
							`<a target="_self" href="${url}"><b><i>Mail Flow Integration page</i></b></a>`);
						this.ns.showErrorMessage(message);
						return;
					}
				}

				this.exchangePowershellPopup[type] = {show: true, source};

				let verifiedDomains = [];
				if (this.planInfo.exchange_server.enabled && this.planInfo.exchange_server.verified_domains?.length) {
					verifiedDomains = this.planInfo.exchange_server.verified_domains;
				}
				else {
					verifiedDomains = this.planInfo.domains.filter(d => d.verified).map(d => d.domain);
				}

				this.exchangePowershellPopup[type].domains = verifiedDomains;
				break;

			default:
				this.exchangePowershellPopup[type] = {show: true};
				break;
		}
	}

	syncPowershellBlocklists = () => {
		this.integrationActionInProcess = true;
		this.rs.exchangeSyncBlocklist().then(res => {
			this.ns.showInfoMessage('Blocklists successfully synced from Exchange');
			this.integrationActionInProcess = false;
		}, () => {
			this.integrationActionInProcess = false;
		});
	}

	verifyWebhook = () => {
		if (this.webHooksUpdateInProcess) {
			return;
		}

		this.webHooksUpdateInProcess = true;

		const configuration = {
			url: this.planInfo.web_hooks.events.url,
			secret: this.planInfo.web_hooks.events.secret
		};

		this.rs.verifyWebhook(configuration).then((response) => {
			this.ns.showInfoMessage('Webhook verification completed successfully');
			this.webHooksUpdateInProcess = false;
		}, (err) => {
			this.webHooksUpdateInProcess = false;
		});
	}

	searchUser = (searchTerm) => {
		searchTerm = searchTerm.toLowerCase();
		this.webHooksUsersPopup.users.forEach(record => {
			if (searchTerm) {
				const isFound = (record.email.toLowerCase().indexOf(searchTerm) > -1);
				if (!isFound) {
					record.hide = true;
					return;
				}
			}

			record.hide = false;
		});
	}

	openUsersFilterPopup = () => {
		this.webHooksUsersPopup = {
			type: this.planInfo.web_hooks.events.users?.length ? 'specific' : 'all',
			users: [],
			loadingUsers: true,
			show: true,
			doneCb:() => {
				if (this.webHooksUsersPopup.type === 'specific') {
					const selectedUsers = this.webHooksUsersPopup.users.filter(itm => itm.selected);
					if (!selectedUsers.length) {
						this.ns.showErrorMessage(this.dic.ERRORS.atLeastOneReportUser)
						return;
					}
					this.planInfo.web_hooks.events.users = selectedUsers.map(itm => itm.email);
					this.webHooksUsersPopup = null;
				}
				else {
					this.planInfo.web_hooks.events.users = [];
					this.webHooksUsersPopup = null;
				}
			}
		};

		this.rs.getAccountCompromisedUsers('').then(response => {
			this.webHooksUsersPopup.loadingUsers = false;
			this.webHooksUsersPopup.users = response;
			this.webHooksUsersPopup.users.forEach(userObj => {
				userObj.selected = this.planInfo.web_hooks.events.users?.includes(userObj.email);
			});
		}, (err) => {
			this.webHooksUsersPopup.loadingUsers = false;
		});
	}

	webHooksUpdateConfiguration = () => {
		if (this.webHooksUpdateInProcess) {
			return;
		}

		this.webHooksUpdateInProcess = true;

		// @ts-ignore
		const selectedEvents = this.webHooksEvents.filter(itm => itm.selected).map(itm => itm.name);
		const configuration = {
			enabled: this.planInfo.web_hooks.events.enabled,
			url: this.planInfo.web_hooks.events.url,
			secret: this.planInfo.web_hooks.events.secret,
			events: selectedEvents,
			users: this.planInfo.web_hooks.events.users,
		};

		this.rs.webHooksUpdateConfiguration(configuration).then((response) => {
			this.ns.showInfoMessage(this.dic.MESSAGES.operationCalled);
			this.webHooksUpdateInProcess = false;
		}, (err) => {
			this.webHooksUpdateInProcess = false;
		});
	};
}
